var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 97,
    viewBox: "0 0 76 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.1728 3V3C45.5917 3 47.9115 3.96134 49.6214 5.67235L70.5667 26.6315C72.0333 28.0992 72.8572 30.0892 72.8572 32.1641V32.1641M43.1728 3H13.3684C8.06924 3 3.77344 7.29582 3.77344 12.595V83.5978C3.77344 88.8969 8.06925 93.1927 13.3684 93.1927H63.2623C68.5614 93.1927 72.8572 88.8969 72.8572 83.5978V32.1641M43.1728 3V22.5691C43.1728 27.8683 47.4686 32.1641 52.7678 32.1641H72.8572",
    stroke: "#292D32",
    strokeWidth: 5.75698
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9909 58.011L56.1843 52.9154C56.5255 52.7449 56.9047 52.6644 57.2858 52.6815C57.6669 52.6987 58.0373 52.813 58.3618 53.0135C58.6863 53.214 58.9542 53.4941 59.1401 53.8272C59.326 54.1603 59.4237 54.5354 59.4239 54.9169V70.0603C59.4237 70.4418 59.326 70.8169 59.1401 71.15C58.9542 71.4832 58.6863 71.7633 58.3618 71.9638C58.0373 72.1643 57.6669 72.2785 57.2858 72.2957C56.9047 72.3129 56.5255 72.2324 56.1843 72.0618L45.9909 66.9663V58.011ZM19.125 53.5333C19.125 52.3458 19.5968 51.2069 20.4365 50.3671C21.2762 49.5274 22.4151 49.0557 23.6027 49.0557H41.5133C42.7008 49.0557 43.8397 49.5274 44.6794 50.3671C45.5192 51.2069 45.9909 52.3458 45.9909 53.5333V71.4439C45.9909 72.6315 45.5192 73.7704 44.6794 74.6101C43.8397 75.4498 42.7008 75.9216 41.5133 75.9216H23.6027C22.4151 75.9216 21.2762 75.4498 20.4365 74.6101C19.5968 73.7704 19.125 72.6315 19.125 71.4439V53.5333Z",
    stroke: "#292D32",
    strokeWidth: 3.83799,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon);
export default __webpack_public_path__ + "static/media/video-icon.6a5420317cf91c856bfddef9147a3f18.svg";
export { ForwardRef as ReactComponent };